import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { OrganizationPartnerInfoApi } from "../../../../../../services/Api/Admin/adminTypes";
import OrganizationSinglePartnerItem from "./OrganizationSinglePartnerItem";

interface Props {
	partners: OrganizationPartnerInfoApi[];
	organizationId: number;
}

const OrganizationPartnersInfoCard = ({ partners, organizationId }: Props) => {
	const { t } = useTranslation("admin");
	const history = useHistory();

	const redirectToPartnersTab = () => {
		document.querySelector(".content")?.scrollTo(0, 0);
		history.push(`/admin/organizations/${organizationId}/partners`);
	};

	return (
		<Card className="partner-card">
			<Card.Body>
				{partners.map((partner, index) => (
					<>
						<OrganizationSinglePartnerItem partner={partner} size={"small"} />
						{index === 0 && partners.length > 1 && <hr className="bg-primary my-3" />}
					</>
				))}
				{partners.length > 1 && (
					<Button variant="add w-100 mt-3" onClick={redirectToPartnersTab}>
						{t("common.action.show_more", { ns: "lib" })}
					</Button>
				)}
			</Card.Body>
		</Card>
	);
};

export default OrganizationPartnersInfoCard;
